import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { COLORS } from '@/shared/constants/colors';

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const VideoWrapper = styled.div`
  padding: 24px;
  background: ${COLORS.white};
  border-radius: 12px;
  gap: 24px;
  display: flex;
  flex-direction: column;
  max-width: 722px;
  width: 100%;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.span`
  font-size: 18px;
  font-weight: 700;
`;

export const ButtonIwStyled = styled(ButtonIw)`
  && {
    background: ${COLORS.systemSky200};
    color: ${COLORS.white};

    &&:hover {
      background: ${COLORS.systemSky300};
    }

    &&:disabled {
      background: ${COLORS.systemSky200};
      opacity: 0.5;
      color: ${COLORS.white};
    }
  }
`;

export const Videos = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
`;
